

import mixx from "../../../../mixin/mixin.js";
import Vue from "vue";
import VueExcelEditor from "vue-excel-editor";

Vue.use(VueExcelEditor);


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      data: [],
      loading: false,
      loading_f: false,
      totales: {
        discountAmount: 0,
        discountamountArg: 0,
        settlementTaxRI: 0,
        settlementTaxRNI: 0
      },
      f_c: {
        desde: this.date_rest(this.currentdate(), -30),
        hasta: this.currentdate()
      }
    };
  },
  component: {
    VueExcelEditor
  },
  computed: {
    reporte: function () {
      return (
        "/billeteras/PP/liquidaciones?dsis=" + window.sssdi  +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },
  mounted: function () {
    $(".box").boxWidget();

    //this.consultar();
  },

  methods: {
    consultar() {
      this.loading = true;

      this.data = [];

      this.$http
        .post(
          "/billeteras/PP/liquidaciones",this.f_c)
        .then(response => {
          this.ventast_tabla = 0;
          if (response.data.status == 1) {
            for (let i = 0; i < response.data.data.length; i++) {

              this.data.push(response.data.data[i])
            }

          }


          this.loading = false;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/reportes/ppLiquidaciones/tventas/tventas.js